import { useCallback, useEffect, useState } from 'react';

import { useTimedEvent } from '@perpay-web/hooks/useTimedEvent';
import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './LoaderCircle.scss';

export const DEFAULT_LOADER_DELAY = 0;

export enum LoaderCircleMode {
    DARK = 'dark',
    LIGHT = 'light',
}

type LoaderCircleProps = {
    delay?: number;
    mode?: LoaderCircleMode;
};

const LoaderCircle = ({
    delay = DEFAULT_LOADER_DELAY,
    mode = LoaderCircleMode.LIGHT,
}: LoaderCircleProps) => {
    const [hidden, setHidden] = useState(delay > 0);
    const timedEventCallback = useCallback(() => {
        setHidden(false);
    }, []);

    const { startTimer, clearTimer } = useTimedEvent(timedEventCallback, delay);

    useEffect(() => {
        startTimer();
        return () => clearTimer();
    }, [clearTimer, startTimer]);

    return hidden ? null : (
        <div className={styles['loader-container']}>
            <div
                className={getClassName(
                    styles.loader,
                    mode === LoaderCircleMode.DARK
                        ? styles['loader--dark']
                        : '',
                )}
            />
        </div>
    );
};

export default LoaderCircle;
